import { EventRegistrationAdditionalStatus, type RegistrantRow } from "./types";

export const EXCESSIVE_SCORE_THRESHOLD = 200;
export const isExcessiveScore = (score: number | null) => (score || 0) >= EXCESSIVE_SCORE_THRESHOLD;

export function normalizeRoundScore(value: unknown): string {
  if (value == null || value === "") return "";
  return String(value);
}

export function formatPatTotalScore(
  roundOneScore: unknown,
  roundTwoScore: unknown,
  serverTotal: number | null
): string {
  const roundOne = normalizeRoundScore(roundOneScore).trim();
  const roundTwo = normalizeRoundScore(roundTwoScore).trim();

  if (roundOne && roundTwo && /^\d+$/.test(roundOne) && /^\d+$/.test(roundTwo)) {
    return String(Number(roundOne) + Number(roundTwo));
  }

  if (serverTotal != null) {
    return String(serverTotal);
  }

  return "--";
}

export function sumRoundScores(roundOneScore: unknown, roundTwoScore: unknown): number | null {
  const roundOne = normalizeRoundScore(roundOneScore).trim();
  const roundTwo = normalizeRoundScore(roundTwoScore).trim();

  if (roundOne && roundTwo && /^\d+$/.test(roundOne) && /^\d+$/.test(roundTwo)) {
    return Number(roundOne) + Number(roundTwo);
  }

  return null;
}

export function getPendingRoundScoreSaves(
  row: Pick<RegistrantRow, "score_18_1" | "score_18_2">,
  roundOneScore: unknown,
  roundTwoScore: unknown
): Array<{ field: "roundOneScore" | "roundTwoScore"; value: string }> {
  const pending: Array<{ field: "roundOneScore" | "roundTwoScore"; value: string }> = [];
  const roundOne = normalizeRoundScore(roundOneScore);
  const roundTwo = normalizeRoundScore(roundTwoScore);

  if (roundOne !== normalizeRoundScore(row.score_18_1)) {
    pending.push({ field: "roundOneScore", value: roundOne });
  }

  if (roundTwo !== normalizeRoundScore(row.score_18_2)) {
    pending.push({ field: "roundTwoScore", value: roundTwo });
  }

  return pending;
}

const titleize = (word: string): string => word[0].toUpperCase() + word.slice(1);
export const patSubmissionStatusOptions = (exclude: string[] = []): { value: string; displayText: string }[] =>
  Object.values(EventRegistrationAdditionalStatus)
    .filter((x) => !exclude.includes(x))
    .map((x) => ({
      value: x,
      displayText: x
        .split("_")
        .map((y) => titleize(y))
        .join(" ")
    }))
    .sort((a, b) => a.displayText.localeCompare(b.displayText));
